import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageSquare, Wrench } from "lucide-react";
import { SITE } from "@/lib/site";

export default function StickyMobileCTA() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-br-black border-t border-br-line text-white grid grid-cols-3" data-testid="mobile-sticky-cta">
      <a href={`tel:${SITE.phoneE164}`} className="flex flex-col items-center justify-center py-3 text-xs gap-1 hover:bg-br-charcoal" data-testid="mobile-cta-call">
        <Phone size={16} className="text-br-bronze-2" /> Call
      </a>
      <Link to="/contact" className="flex flex-col items-center justify-center py-3 text-xs gap-1 border-l border-br-line hover:bg-br-charcoal" data-testid="mobile-cta-quote">
        <MessageSquare size={16} className="text-br-bronze-2" /> Quote
      </Link>
      <Link to="/maintenance-plans" className="flex flex-col items-center justify-center py-3 text-xs gap-1 border-l border-br-line hover:bg-br-charcoal" data-testid="mobile-cta-plans">
        <Wrench size={16} className="text-br-bronze-2" /> Plans
      </Link>
    </div>
  );
}
